import { Button, Card } from '@tecsinapse/cortex-react'
import { Trans } from '@lingui/react/macro'
import { Link } from 'react-router-dom'
import React from 'react'
import { Icon } from './icon'
import { useRedesSociais } from '../hooks/use-redes-sociais'
import { EventGoal, EventOrigin, logEvent } from '@/core/analytics'
import { AnalyticsEvents } from '@/core/analytics/analytics-eventes-enum'

export const Footer = () => {
  const redesSociais = useRedesSociais()

  if (redesSociais?.length < 1) return null

  return (
    <Card className={'flex justify-between items-center my-deca px-kilo'}>
      <div className={'flex flex-col gap-1'}>
        <p className='text-h1 font-bold'>
          <Trans>Nos acompanhe nas redes sociais</Trans>
        </p>
        <p className='text-xs text-secondary-medium'>
          <Trans>
            Fique por dentro de tudo que acontece e não perca nenhuma ação.
          </Trans>
        </p>
      </div>
      <div className={'flex my-deca gap-x-deca'}>
        {redesSociais?.map(redesSociais => {
          return (
            <Link
              to={redesSociais.url}
              className={'no-underline'}
              key={redesSociais.id}
              target='_blank'
              onClick={() => {
                logEvent({
                  name: AnalyticsEvents.REDES_SOCIAIS,
                  params: {
                    origin: EventOrigin.button,
                    goal: EventGoal.navigation
                  }
                })
              }}
            >
              <Button size='square' variant='filled' alt={redesSociais.nome}>
                <Icon name={redesSociais.name} pack={redesSociais.pack} />
              </Button>
            </Link>
          )
        })}
      </div>
    </Card>
  )
}
